document.addEventListener("DOMContentLoaded", function () {
  // === Header scroll effect ===
  var h = document.querySelector(".site-header");
  if (h) {
    window.addEventListener("scroll", function () {
      h.classList.toggle("scrolled", window.scrollY > 50);
    });
  }

  // === Mobile menu toggle ===
  var mobileToggle = document.querySelector(".mobile-toggle");
  var mobileMenu = document.querySelector(".mobile-menu");
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener("click", function () {
      mobileMenu.classList.toggle("open");
    });
  }

  // === Varied Scroll Animations ===
  var animateElements = document.querySelectorAll("[data-animate]");

  function handleScrollAnimations() {
    var viewportHeight = window.innerHeight;
    animateElements.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      var inView = rect.top < viewportHeight * 0.88 && rect.bottom > 0;
      if (inView && !el.classList.contains("animated")) {
        el.classList.add("animated");
      }
    });
  }

  if (animateElements.length > 0) {
    handleScrollAnimations();
    window.addEventListener("scroll", handleScrollAnimations, { passive: true });
  }

  // === Product Page: Thumbnail gallery ===
  var thumbs = document.querySelectorAll(".product-thumb");
  var mainImg = document.getElementById("main-img");
  if (thumbs.length > 0 && mainImg) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        thumbs.forEach(function (t) { t.classList.remove("active"); });
        thumb.classList.add("active");
        mainImg.src = thumb.getAttribute("data-img-url");
      });
    });
  }

  // === Product Page: Size/Color selectors ===
  var sizeButtons = document.querySelectorAll(".size-btn");
  sizeButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var group = btn.parentElement;
      group.querySelectorAll(".size-btn").forEach(function (b) { b.classList.remove("active"); });
      btn.classList.add("active");
      updateVariant();
    });
  });

  var colorButtons = document.querySelectorAll(".color-btn");
  colorButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var group = btn.parentElement;
      group.querySelectorAll(".color-btn").forEach(function (b) { b.classList.remove("active"); });
      btn.classList.add("active");
      updateVariant();
    });
  });

  // Update variant based on selected options + swap image
  function updateVariant() {
    var selectedOptions = [];
    document.querySelectorAll(".product-option-group").forEach(function (group) {
      var activeBtn = group.querySelector(".size-btn.active, .color-btn.active");
      var selectEl = group.querySelector(".product-option-select");
      if (activeBtn) {
        selectedOptions.push(activeBtn.getAttribute("data-value"));
      } else if (selectEl) {
        selectedOptions.push(selectEl.value);
      }
    });

    var variantSelect = document.getElementById("product-variant-select");
    if (!variantSelect) return;

    var options = variantSelect.querySelectorAll("option");
    options.forEach(function (option) {
      var optionData = JSON.parse(option.getAttribute("data-options") || "[]");
      var match = selectedOptions.every(function (val, i) { return optionData[i] === val; });
      if (match) {
        variantSelect.value = option.value;
        var addBtn = document.getElementById("add-to-cart-btn");
        if (option.getAttribute("data-available") === "false") {
          addBtn.textContent = "Sold Out";
          addBtn.disabled = true;
        } else {
          addBtn.textContent = "Add to Cart";
          addBtn.disabled = false;
        }

        // === COLOR-VARIANT IMAGE SWITCHING ===
        var variantImgUrl = option.getAttribute("data-image-url");
        var mainImgEl = document.getElementById("main-img");
        if (variantImgUrl && mainImgEl) {
          mainImgEl.src = variantImgUrl;
          // Also highlight the matching thumbnail
          var allThumbs = document.querySelectorAll(".product-thumb");
          allThumbs.forEach(function (t) {
            t.classList.remove("active");
            if (t.getAttribute("data-img-url") === variantImgUrl) {
              t.classList.add("active");
            }
          });
        }
      }
    });
  }

  // Option select change
  var optionSelects = document.querySelectorAll(".product-option-select");
  optionSelects.forEach(function (sel) {
    sel.addEventListener("change", updateVariant);
  });

  // === Quantity buttons ===
  var qtyMinus = document.getElementById("qty-minus");
  var qtyPlus = document.getElementById("qty-plus");
  var qtyInput = document.getElementById("qty-input");

  if (qtyMinus && qtyPlus && qtyInput) {
    qtyMinus.addEventListener("click", function () {
      var val = parseInt(qtyInput.value) || 1;
      if (val > 1) qtyInput.value = val - 1;
    });
    qtyPlus.addEventListener("click", function () {
      var val = parseInt(qtyInput.value) || 1;
      qtyInput.value = val + 1;
    });
  }

  // === Cart Quantity Buttons ===
  document.querySelectorAll(".cart-qty-minus").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var key = btn.getAttribute("data-key");
      var input = document.querySelector('.cart-qty-input[data-key="' + key + '"]');
      if (input) {
        var val = parseInt(input.value) || 1;
        if (val > 1) {
          input.value = val - 1;
          updateCartItem(key, val - 1);
        }
      }
    });
  });

  document.querySelectorAll(".cart-qty-plus").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var key = btn.getAttribute("data-key");
      var input = document.querySelector('.cart-qty-input[data-key="' + key + '"]');
      if (input) {
        var val = parseInt(input.value) || 1;
        input.value = val + 1;
        updateCartItem(key, val + 1);
      }
    });
  });

  function updateCartItem(key, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function () {
      window.location.reload();
    });
  }

  // === Product Filters ===
  var filterBtns = document.querySelectorAll(".filter-btn");
  var productsGrid = document.getElementById("products-grid");
  var activeFiltersEl = document.getElementById("active-filters");
  var activeFilterName = document.getElementById("active-filter-name");
  var clearFilterBtn = document.getElementById("clear-filter");
  var noProductsMsg = document.getElementById("no-products-msg");

  if (filterBtns.length > 0 && productsGrid) {
    filterBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        filterBtns.forEach(function (b) { b.classList.remove("active"); });
        btn.classList.add("active");

        var filter = btn.getAttribute("data-filter");
        var cards = productsGrid.querySelectorAll(".product-card");
        var visibleCount = 0;

        cards.forEach(function (card) {
          var type = card.getAttribute("data-product-type") || "";
          if (filter === "all" || type.toLowerCase().indexOf(filter.toLowerCase()) > -1) {
            card.style.display = "";
            visibleCount++;
          } else {
            card.style.display = "none";
          }
        });

        if (filter !== "all" && activeFiltersEl && activeFilterName) {
          activeFiltersEl.style.display = "flex";
          activeFilterName.textContent = btn.textContent;
        } else if (activeFiltersEl) {
          activeFiltersEl.style.display = "none";
        }

        if (noProductsMsg) {
          noProductsMsg.style.display = visibleCount === 0 ? "block" : "none";
        }
      });
    });

    if (clearFilterBtn) {
      clearFilterBtn.addEventListener("click", function () {
        filterBtns.forEach(function (b) { b.classList.remove("active"); });
        filterBtns[0].classList.add("active");
        productsGrid.querySelectorAll(".product-card").forEach(function (card) {
          card.style.display = "";
        });
        if (activeFiltersEl) activeFiltersEl.style.display = "none";
        if (noProductsMsg) noProductsMsg.style.display = "none";
      });
    }
  }

  // === Cart Note auto-save ===
  var cartNote = document.getElementById("cart-note");
  if (cartNote) {
    var noteTimeout;
    cartNote.addEventListener("input", function () {
      clearTimeout(noteTimeout);
      noteTimeout = setTimeout(function () {
        fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ note: cartNote.value })
        });
      }, 500);
    });
  }

  // === Nav dropdown hover ===
  var dropdownParent = document.querySelector(".nav-dropdown-parent");
  if (dropdownParent) {
    dropdownParent.addEventListener("mouseenter", function () {
      this.querySelector(".nav-dropdown").classList.add("open");
    });
    dropdownParent.addEventListener("mouseleave", function () {
      this.querySelector(".nav-dropdown").classList.remove("open");
    });
  }

  // === Mobile submenu toggle ===
  var mobileSubmenuToggle = document.querySelector(".mobile-submenu-toggle");
  if (mobileSubmenuToggle) {
    mobileSubmenuToggle.addEventListener("click", function (e) {
      e.preventDefault();
      this.parentElement.querySelector(".mobile-submenu").classList.toggle("open");
    });
  }

  // === Photo gallery marquee pause on hover ===
  var galleryTrack = document.querySelector(".gallery-track");
  if (galleryTrack) {
    galleryTrack.addEventListener("mouseenter", function () {
      this.style.animationPlayState = "paused";
    });
    galleryTrack.addEventListener("mouseleave", function () {
      this.style.animationPlayState = "running";
    });
  }
});

/* ============================================================
   The Brav — search + load more + design grouping
   ============================================================ */
document.addEventListener("DOMContentLoaded", function () {
  var money = function (cents, format) {
    return format || "€" + (cents / 100).toFixed(2);
  };

  /* === Design grouping (collapse hoodie/t-shirt duplicates) === */
  function groupCards(grid, cards) {
    if (!grid || grid.getAttribute("data-group-designs") !== "true") return cards;
    grid.__seen = grid.__seen || {};
    var kept = [];
    cards.forEach(function (card) {
      var key = card.getAttribute("data-design-key");
      var garment = card.getAttribute("data-garment");
      if (!key) { kept.push(card); return; }
      var existing = grid.__seen[key];
      if (existing) {
        if (garment && existing.getAttribute("data-garment") !== garment &&
            (garment === "hoodie" || garment === "tshirt")) {
          var wrap = existing.querySelector(".product-img-wrap");
          var badge = wrap && wrap.querySelector(".product-badge:not(.product-badge--soldout)");
          if (badge) {
            badge.textContent = "Hoodie · T-Shirt";
            badge.setAttribute("data-combo-badge", "");
          }
          var note = existing.querySelector("[data-combo-note]");
          if (note) note.removeAttribute("hidden");
        }
        if (card.parentNode) card.parentNode.removeChild(card);
        return;
      }
      grid.__seen[key] = card;
      kept.push(card);
    });
    return kept;
  }

  var grid = document.getElementById("products-grid");
  if (grid) groupCards(grid, Array.prototype.slice.call(grid.querySelectorAll(".product-card")));

  /* === Load more products === */
  var loadBtn = document.getElementById("load-more-btn");
  if (loadBtn && grid) {
    var loading = false;
    loadBtn.addEventListener("click", function (e) {
      e.preventDefault();
      if (loading) return;
      var url = loadBtn.getAttribute("data-next-url");
      if (!url) return;
      loading = true;
      loadBtn.classList.add("is-loading");
      loadBtn.textContent = "Loading…";
      fetch(url, { headers: { "X-Requested-With": "fetch" } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var newCards = Array.prototype.slice.call(doc.querySelectorAll("#products-grid .product-card"));
          newCards.forEach(function (card) {
            card.classList.add("animated");
            card.style.animationDelay = "0s";
            grid.appendChild(card);
          });
          groupCards(grid, newCards);

          var nextBtn = doc.getElementById("load-more-btn");
          var counter = document.getElementById("load-more-count");
          var docCount = doc.getElementById("load-more-count");
          if (counter && docCount) counter.innerHTML = docCount.innerHTML;
          if (nextBtn) {
            loadBtn.setAttribute("data-next-url", nextBtn.getAttribute("data-next-url"));
            loadBtn.setAttribute("href", nextBtn.getAttribute("href"));
            loadBtn.textContent = "Load more products";
          } else {
            var wrap = document.getElementById("load-more-wrap");
            if (wrap) wrap.parentNode.removeChild(wrap);
          }
        })
        .catch(function () {
          window.location.href = loadBtn.getAttribute("data-next-url");
        })
        .then(function () {
          loading = false;
          loadBtn.classList.remove("is-loading");
        });
    });
  }

  /* === Header search === */
  var searchToggle = document.getElementById("search-toggle");
  var searchPanel = document.getElementById("search-panel");
  var searchInput = document.getElementById("search-input");
  var searchClose = document.getElementById("search-close");
  var searchResults = document.getElementById("search-results");

  function closeSearch() {
    if (!searchPanel) return;
    searchPanel.classList.remove("open");
    searchPanel.setAttribute("hidden", "");
    if (searchToggle) searchToggle.setAttribute("aria-expanded", "false");
  }

  if (searchToggle && searchPanel) {
    searchToggle.addEventListener("click", function () {
      var isOpen = searchPanel.classList.contains("open");
      if (isOpen) { closeSearch(); return; }
      searchPanel.removeAttribute("hidden");
      requestAnimationFrame(function () { searchPanel.classList.add("open"); });
      searchToggle.setAttribute("aria-expanded", "true");
      if (searchInput) searchInput.focus();
    });
  }
  if (searchClose) searchClose.addEventListener("click", closeSearch);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeSearch(); });

  if (searchInput && searchResults) {
    var timer = null;
    searchInput.addEventListener("input", function () {
      var q = searchInput.value.trim();
      clearTimeout(timer);
      if (q.length < 2) {
        searchResults.setAttribute("hidden", "");
        searchResults.innerHTML = "";
        return;
      }
      timer = setTimeout(function () {
        fetch("/search/suggest.json?q=" + encodeURIComponent(q) +
              "&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last")
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              searchResults.innerHTML = '<p class="search-empty-msg">No products found for “' + q.replace(/</g, "&lt;") + '”.</p>';
              searchResults.removeAttribute("hidden");
              return;
            }
            var html = products.map(function (p) {
              var img = p.featured_image && p.featured_image.url
                ? '<img src="' + p.featured_image.url + '" alt="' + (p.title || "").replace(/"/g, "&quot;") + '" loading="lazy">'
                : '<span class="search-result-img-empty"></span>';
              var price = p.price ? '<span class="search-result-price">' + p.price + "</span>" : "";
              return '<a class="search-result" href="' + p.url + '">' +
                     '<span class="search-result-img">' + img + "</span>" +
                     '<span class="search-result-body"><span class="search-result-title">' +
                     (p.title || "") + "</span>" + price + "</span></a>";
            }).join("");
            html += '<a class="search-result search-result--all" href="/search?q=' + encodeURIComponent(q) + '&type=product">View all results →</a>';
            searchResults.innerHTML = html;
            searchResults.removeAttribute("hidden");
          })
          .catch(function () { searchResults.setAttribute("hidden", ""); });
      }, 220);
    });
  }

  document.addEventListener("click", function (e) {
    if (!searchPanel || !searchPanel.classList.contains("open")) return;
    if (searchPanel.contains(e.target) || (searchToggle && searchToggle.contains(e.target))) return;
    closeSearch();
  });
});

/* ============================================================
   The Brav — Hoodie / T-Shirt style switcher resolver
   Mirrors snippets/design-key.liquid + snippets/design-pairs.liquid so the
   product page can find the sibling garment even when Liquid's 50-product
   loop cap hides it.
   ============================================================ */
(function () {
  var GARMENT_WORDS = [
    "hooded sweatshirt", "hooded", "sweatshirts", "sweatshirt", "hoodies",
    "hoodie", "hoody", "hoodys", "crewneck", "sweater", "trui", "hood",
    "t shirts", "t shirt", "tshirts", "tshirt", "tees", "tee", "shirts",
    "shirt", "t"
  ];
  var FILLER_WORDS = [
    "unisex", "premium", "heavy blend", "heavyweight", "heavy", "blend",
    "organic", "oversized", "oversize", "regular fit", "fit", "edition",
    "the brav", "thebrav", "brav", "and", "en", "with", "the"
  ];
  var YEARS = ["mmxxvi", "mmxxv", "mmxxiv", "mmxxiii", "mmxxii", "mmxxi",
               "2026", "2025", "2024", "2023", "2022", "2021"];

  function stripPhrases(s, list) {
    list.forEach(function (w) {
      var re = new RegExp("(^|\\s)" + w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "(?=\\s|$)", "g");
      var prev;
      do { prev = s; s = s.replace(re, " "); } while (s !== prev);
    });
    return s;
  }

  function pairOverride(key) {
    var k = key;
    function variant(base) {
      if (k.indexOf("black") > -1) return base + " black";
      if (k.indexOf("white") > -1) return base + " white";
      if (k.indexOf("light") > -1) return base + " light";
      if (k.indexOf("dark") > -1) return base + " dark";
      return base;
    }
    if (k.indexOf("air assault") > -1) return variant("air assault");
    if (k.indexOf("mmxxvi") > -1) return variant("mmxxvi");
    return "";
  }

  function designKey(title) {
    var s = " " + String(title || "").toLowerCase() + " ";
    s = s.replace(/[–—|/\\\-_.,:;()\[\]"'’“”&+]/g, " ");
    s = s.replace(/\s+/g, " ");
    YEARS.forEach(function (y) {
      s = s.replace(new RegExp("(^|\\s)" + y + "(?=\\s|$)", "g"), " mmxxvi ");
    });
    s = stripPhrases(s, GARMENT_WORDS);
    s = stripPhrases(s, FILLER_WORDS);
    s = s.replace(/(^|\s)m r(?=\s|$)/g, " mr ");
    s = s.replace(/\s+/g, " ").trim();
    var alias = pairOverride(s);
    return alias || s;
  }

  function garmentType(p) {
    var hay = [(p.type || p.product_type || ""), (p.title || ""),
               (Array.isArray(p.tags) ? p.tags.join(" ") : (p.tags || ""))].join(" ").toLowerCase();
    if (/hoodie|hoody|sweatshirt|sweater|crewneck|trui/.test(hay)) return "hoodie";
    if (/t-shirt|tshirt|t shirt|tee|shirt/.test(hay)) return "tshirt";
    return "other";
  }

  function fmtMoney(value) {
    var n = parseFloat(value);
    if (isNaN(n)) return "";
    return "€" + n.toFixed(2).replace(".", ",");
  }

  function fetchCollection(handle) {
    var out = [];
    function page(n) {
      return fetch("/collections/" + handle + "/products.json?limit=250&page=" + n)
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (data) {
          var list = (data && data.products) || [];
          out = out.concat(list);
          if (list.length === 250 && n < 6) return page(n + 1);
          return out;
        })
        .catch(function () { return out; });
    }
    return page(1);
  }

  function btnHTML(label, entry, isCurrent) {
    var price = entry.available === false ? "Sold Out" : fmtMoney(entry.price);
    var inner = '<span class="style-btn-name">' + label + "</span>" +
                '<span class="style-btn-price">' + price + "</span>";
    if (isCurrent) return '<span class="style-btn active" aria-current="true">' + inner + "</span>";
    return '<a class="style-btn' + (entry.available === false ? " style-btn--soldout" : "") +
           '" href="' + entry.url + '">' + inner + "</a>";
  }

  document.addEventListener("DOMContentLoaded", function () {
    var box = document.querySelector("[data-style-switcher]");
    if (!box || box.getAttribute("data-resolved") === "true") return;

    var key = box.getAttribute("data-design-key") || "";
    var current = box.getAttribute("data-garment");
    if (!key || (current !== "hoodie" && current !== "tshirt")) return;

    Promise.all([fetchCollection("hoodies"), fetchCollection("t-shirts")])
      .then(function (lists) {
        var found = { hoodie: null, tshirt: null };
        lists.forEach(function (list) {
          list.forEach(function (p) {
            if (designKey(p.title) !== key) return;
            var t = garmentType(p);
            if (t !== "hoodie" && t !== "tshirt") return;
            if (found[t]) return;
            var v = (p.variants || [])[0] || {};
            found[t] = {
              url: "/products/" + p.handle,
              price: v.price,
              available: (p.variants || []).some(function (x) { return x.available; })
            };
          });
        });

        found[current] = found[current] || { url: window.location.pathname, price: null, available: true };
        if (!found.hoodie || !found.tshirt) return;

        var list = box.querySelector("[data-style-switcher-list]");
        if (!list) return;
        list.innerHTML = btnHTML("Hoodie", found.hoodie, current === "hoodie") +
                         btnHTML("T-Shirt", found.tshirt, current === "tshirt");
        if (current === "hoodie" || current === "tshirt") {
          var cur = list.querySelector(".style-btn.active .style-btn-price");
          var shown = document.querySelector(".product-detail-price");
          if (cur && shown && !cur.textContent.trim()) cur.textContent = shown.textContent.trim();
        }
        box.classList.remove("style-switcher-group--pending");
        box.removeAttribute("hidden");
        box.setAttribute("data-resolved", "true");
      })
      .catch(function () {});
  });
})();
